import type { SocialPlatform } from "../model/types";

export const socialKeys = {
  all: ["social"] as const,
  connections: () => [...socialKeys.all, "connections"] as const,
  platform: (platform: SocialPlatform) =>
    [...socialKeys.all, "platform", platform] as const,
  media: (platform: SocialPlatform, limit: number) =>
    [...socialKeys.platform(platform), "media", limit] as const,
  disconnectPreview: (platform: SocialPlatform) =>
    [...socialKeys.platform(platform), "disconnect-preview"] as const,
};
